import videojs from 'video.js';
import PollIcon from '../../assets/images/poll-white-24dp.svg';

var TIMED_EVENT_TYPE = 'mediasite/poll';
let localize;

/**
 * The PollNotificationPlugin module.<br><br>
 * Note: this module is optional and might not be available on every MediasitePlayer instance.
 * @member {PollNotificationPlugin|undefined} pollNotification
 * @memberof MediasitePlayer#
 */

/**
 * Listens for timed events during live playback and shows a notification whenever a new poll becomes available.<br><br>Note: this plugin currently has no configurable options.
 * @hideconstructor
 * @extends {external:"videojs.Plugin"}
 **/
class PollNotificationPlugin extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        localize = player.localize?.bind(player);
        super(player, options);
        this.log('Loaded poll notification plugin.');
        this.on(player, 'timedeventreached', this.#handleTimedEvent);
    }

    #handleTimedEvent(event, { id, time, type, payload }) {
        const isLive = this.player.usingPlugin('live');
        const pollsUrl = this.player.polls().url;
        if (isLive && pollsUrl && type === TIMED_EVENT_TYPE) {
            this.log('Received a poll notification');
            this.player.notifications().add(localize('Poll available'), {
                callback: () => {
                    this.player.polls().open();
                },
                icon: PollIcon,
                timeout: Infinity,
                description: localize('Click to open in new window')
            });
        }
    }
}

export { PollNotificationPlugin };
